import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { HelmetProvider } from 'react-helmet-async'
import { routeTree } from './routeTree.gen'

import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import '@fontsource/special-gothic-expanded-one/latin-400.css'
import '@fontsource/redaction-10/latin-400.css'
import '@fontsource/redaction-20/latin-400.css'
import '@fontsource/redaction-35/latin-400.css'
import '@fontsource/redaction-50/latin-400.css'
import '@fontsource/redaction-70/latin-400.css'
import '@fontsource/redaction-100/latin-400.css'

import './styles/globals.css'

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </StrictMode>,
  )
}
